import React, { useEffect, useRef } from 'react';

export const CALENDLY_URL = 'https://calendly.com/buildwithprima/30min';

/* Inline Calendly widget — initialised imperatively so it also works when the
   element is mounted after the Calendly script has already loaded. */
export const CalendlyInline = ({ className = '', style, testId = 'calendly-embed' }) => {
  const containerRef = useRef(null);

  useEffect(() => {
    const url = `${CALENDLY_URL}?hide_event_type_details=1&hide_gdpr_banner=1&background_color=2C0616&text_color=F5F0E8&primary_color=C9A55A`;

    const init = () => {
      if (!containerRef.current || containerRef.current.childElementCount > 0) return;
      window.Calendly?.initInlineWidget({ url, parentElement: containerRef.current });
    };

    if (window.Calendly) {
      init();
      return;
    }

    let script = document.querySelector('script[data-calendly-widget]');
    if (!script) {
      script = document.createElement('script');
      script.src = 'https://assets.calendly.com/assets/external/widget.js';
      script.async = true;
      script.setAttribute('data-calendly-widget', 'true');
      document.body.appendChild(script);
    }
    script.addEventListener('load', init);
    return () => script.removeEventListener('load', init);
  }, []);

  return <div ref={containerRef} className={className} style={style} data-testid={testId} />;
};
